import { AuthService } from './../../../core/services/auth-service/auth.service';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  codeSended,
  invalidVerificationCode,
  serverError,
  successCodeVerficiation,
} from './../../../core/models/messages';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { ReCaptchaService } from '@shared/services/reCaptcha.service';
@Component({
  selector: 'app-code-verification',
  templateUrl: './code-verification.component.html',
  styleUrls: ['./code-verification.component.css'],
})
export class CodeVerificationComponent {
  /* formGroup */
  generateCodeForm: FormGroup = this.codeForm();
  userEmail!: string;
  loadSpinner: boolean = false;
  constructor(
    private toastrService: ToastrService,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private reCaptchaService: ReCaptchaService,
  ) {}

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe({
      next: (params: any) => {
        this.userEmail = params.params['email'];
        console.log('userEmail', this.userEmail);
      },
    });
  }
  /* create code from */
  codeForm() {
    return this.formBuilder.group({
      number1: ['', Validators.required],
      number2: ['', Validators.required],
      number3: ['', Validators.required],
      number4: ['', Validators.required],
    });
  }
  /* send code verification  */
  codeVerification() {
    if (this.generateCodeForm.valid) {
      this.reCaptchaService.executeAction('codeVerification').then(token => {
       let codeVerification = Object.values(this.generateCodeForm.value).join(
        ''
       );
      this.spinner.show();
      this.authService.codeVerification({ email: this.userEmail, code: codeVerification, recaptchaToken: token })
        .pipe()
        .subscribe({
          next: (data) => {
             if (data.status == 200) {
            this.toastrService.success(successCodeVerficiation);
            this.router.navigateByUrl('/auth/login');
            this.spinner.hide();
             }
          
          },
          error: (err) => {
            this.generateCodeForm.reset();
            this.spinner.hide();
            if (err?.error) {
              this.toastrService.error(
                err.error.status === 404 ? invalidVerificationCode : serverError
              );
            }
          },
        });
      }).catch(err => {
        this.spinner.hide();
        this.toastrService.error('reCAPTCHA verification failed. Please try again.');
      });
    }
  }

  resendCodeVerification() {
    this.reCaptchaService.executeAction('resendCodeVerification').then(token => {
        this.spinner.show();
        this.generateCodeForm.reset();
        const data = { email: this.userEmail, recaptchaToken: token };
        this.authService
          .resendCodeVerification(data)
          .pipe()
        .subscribe({
          next: (data) => {
            this.spinner.hide();
            this.toastrService.success(codeSended);
          },
          error: (err) => {
            this.spinner.hide();
            if (err?.error) {
              this.toastrService.error(err);
            }
          },
        });
      }).catch(err => {
      this.spinner.hide();
      this.toastrService.error('reCAPTCHA verification failed. Please try again.');
    });
  }
}
